import { render, staticRenderFns } from "./WanXiangDetail.vue?vue&type=template&id=bdf735c2&scoped=true&"
import script from "./WanXiangDetail.vue?vue&type=script&lang=js&"
export * from "./WanXiangDetail.vue?vue&type=script&lang=js&"
import style0 from "./WanXiangDetail.vue?vue&type=style&index=0&id=bdf735c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf735c2",
  null
  
)

export default component.exports